import React from "react";

const Hello = ({ userName }) => {
    return (
        <div data-testid="hello-component">
            <div className="row fs-2 mt-5 pt-5">
                <div className="col-12">
                    Hello&nbsp;<b>{userName}</b>
                </div>
            </div>
            <div className="row">
                &nbsp;
            </div>
            <div className="row">
                &nbsp;
            </div>
            <div className="row fw-bold">
                <div className="col-12">
                    Welcome to confirmly
                </div>
            </div>
            <div className="row">
                &nbsp;
            </div>
            <div className="row pb-5">
                <div className="col-12">
                    This service is for you to verify a law firm&apos;s client bank account before sending any money. We will check the bank details you have been given against our records and let you know whether they are a match or not.
                </div>
            </div>
        </div>
    );
}

export default Hello;